var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-space-around":""}},[_c('button',{staticClass:"help-btn",attrs:{"tabindex":"-1","type":"button"},on:{"click":function($event){return _vm.showHelp()}}},[_vm._v("\n        ?\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }